import $ from 'jquery';

const GridModalLoader = (function () {
  const loader = '<div class="ui active inline loader black-loader"></div>';

  const init = () => {
    $(document).on('click', '.js__ajax-modal-action', function (e) {
      e.preventDefault();

      const $trigger = $(this);
      const url = $trigger.data('url');
      const modalSelector = $trigger.data('modal-target');
      const $modal = modalSelector ? $(modalSelector) : $('.js__ajax-modal');

      if (!$modal.length || !url) {
        return;
      }

      $modal.find('.js__close-btn').on('click', () => {
        $modal.modal('hide');
      });

      const $content = $modal.find('.js__ajax-modal-content');
      resetModal($content);

      $modal
        .modal({
          autofocus: false,
          observeChanges: true,
          keyboardShortcuts: false,
          onShow() {
            setModalContent(url, $content);
          },
          onHidden() {
            resetModal($content);
          },
        })
        .modal('show');
    });
  };

  function setModalContent(url, $container) {
    $.get(url)
      .done(res => {
        $container.html(res);
        bindModalForms($container);
        focusAutofocus($container);
      })
      .fail(() => {
        $container.html('<div class="ui negative message">Unable to load content.</div>');
      });
  }

  function resetModal($container) {
    $container.html(loader);
  }

  function bindModalForms($scope) {
    $scope
      .find('form.js__ajax-modal-form')
      .off('submit.gridModal')
      .on('submit.gridModal', function (e) {
        e.preventDefault();

        const $form = $(this);
        const $container = $form.closest('.js__ajax-modal-content');
        const action = $form.attr('action');
        const method = ($form.attr('method') || 'GET').toUpperCase();
        const clearOnError = $form.data('clearOnError');

        $form.addClass('loading');

        $.ajax({
          url: action,
          method,
          data: $form.serialize(),
        })
          .done((res, textStatus, xhr) => {
            const contentType = xhr.getResponseHeader('Content-Type') || '';
            if (contentType.indexOf('application/json') !== -1) {
              const data = typeof res === 'string' ? JSON.parse(res) : res;
              // Successful responses may instruct the client to redirect.
              const redirectTarget = data.redirect || data.redirectUrl;
              if (redirectTarget && xhr.status === 200) {
                window.location.href = redirectTarget;
                return;
              }
            }

            if (typeof res === 'string') {
              $container.html(res);
              bindModalForms($container);
              focusAutofocus($container);
            }
          })
          .fail(xhr => {
            const response = xhr.responseText;
            if (response) {
              $container.html(response);
              bindModalForms($container);
              clearInputs($container, clearOnError);
              focusAutofocus($container);
            } else {
              $container.html('<div class="ui negative message">Unable to load content.</div>');
            }
          })
          .always(() => {
            $form.removeClass('loading');
          });
      });
  }

  function focusAutofocus($scope) {
    const $target = $scope.find('[autofocus]').first();

    if ($target.length) {
      setTimeout(() => {
        $target.trigger('focus');
      }, 0);
    }
  }

  function clearInputs($scope, clearConfig) {
    if (!clearConfig || clearConfig === 'none') {
      return;
    }

    const selector =
      clearConfig === 'all'
        ? 'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="checkbox"]):not([type="radio"]), textarea'
        : clearConfig;

    const $fields = $scope.find(selector);

    if ($fields.length) {
      $fields.val('');
    }
  }

  return {
    init,
  };
})();

export default GridModalLoader;
